"use strict";

exports.__esModule = true;
exports.default = getMainColor;
var _color = require("./color");
var linearGradientCheckRegex = /linear-gradient/;
var rgbCheckRegex = /^rgb/;
var rgbACheckRegex = /^rgba/;
function isLinearGradient(hexOrGradient) {
  return linearGradientCheckRegex.test(hexOrGradient);
}
function isRGB(rgbOrHexOrGradient) {
  return rgbCheckRegex.test(rgbOrHexOrGradient);
}
function isRGBA(rgbOrHexOrGradient) {
  return rgbACheckRegex.test(rgbOrHexOrGradient);
}

// берем первый цвет из пары, задающей градиент
// Примеры градиента:
// linear-gradient(to right, #9cadbe 30%, #7e8fa3 51%)
// linear-gradient(to right, #9cadbe, #7e8fa3)
// linear-gradient(-45deg, rgb(23, 41, 73), rgb(23, 41, 73))
// linear-gradient(-45deg, rgb(23, 41, 73) 0%, rgb(23, 41, 73) 100%))
var linearGradientMainColorRegex = /linear-gradient\(.+?,\s?(?:(#[\w\d]*)|rgb\((\d+),\s?(\d+),\s?(\d+)\))/;
var rgbMainColorRegex = /\((\d+),\s?(\d+),\s?(\d+)/;

// eslint-disable-next-line import/prefer-default-export
function getMainColor(rgbOrHexOrGradient) {
  var result;
  if (isRGBA(rgbOrHexOrGradient)) {
    result = (0, _color.rgba2hex)(rgbOrHexOrGradient);
  } else if (isRGB(rgbOrHexOrGradient)) {
    var match = rgbMainColorRegex.exec(rgbOrHexOrGradient);
    result = (0, _color.rgb2hex)({
      r: Number(match[1]),
      g: Number(match[2]),
      b: Number(match[3])
    });
  } else if ((0, _color.isHexColor)(rgbOrHexOrGradient)) {
    result = rgbOrHexOrGradient;
  } else if ((0, _color.isHexAColor)(rgbOrHexOrGradient)) {
    result = (0, _color.hexa2hex)(rgbOrHexOrGradient);
  } else if (isLinearGradient(rgbOrHexOrGradient)) {
    var _match = linearGradientMainColorRegex.exec(rgbOrHexOrGradient);

    // hex
    if (_match[1] !== undefined) {
      // eslint-disable-next-line prefer-destructuring
      result = _match[1];
      // rgb
    } else if (_match[2] !== undefined) {
      result = (0, _color.rgb2hex)({
        r: Number(_match[2]),
        g: Number(_match[3]),
        b: Number(_match[4])
      });
    }
  }
  return result;
}